const useSlug = () => () => {
    const { pathname } = new URL(window.location);

    const splittedPath = pathname.split('/');
    
    return splittedPath[1];
}

export default useSlug;